<section id="hero" class="d-flex align-items-center">
    <drme-main-slider class="w-100"></drme-main-slider>
</section>


<main id="main">
    <section id="about" class="about">
        <drme-about-us class="w-100"></drme-about-us>
    </section>

    <section id="services" class="services section-bg">
        <drme-our-services class="w-100"></drme-our-services>
    </section>

    <section id="portfolio" class="portfolio">
        <drme-social class="w-100"></drme-social>
    </section>

    <section id="clients" class="clients section-bg">
        <drme-licences class="w-100"></drme-licences>
    </section>
</main>